module.exports = __webpack_public_path__ + "img/goal_flug.2ec4d96b.svg";